// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2qv9r","balanceDisclaimer":"posDashboard_balanceDisclaimer__nPpYA"};